module.exports = __webpack_public_path__ + "img/wasted_logo.bc20e2f5.jpg";